export default __webpack_public_path__ + "static/media/wifi-2.c6d108a9.svg";